import { useDispatch, useSelector } from 'react-redux'
import './App.css'
import AppRoutes from './routes/AppRoutes'
import { AppDispatch, RootState } from './redux/store'
import { useEffect } from 'react'
import { fetchUserData } from './redux/asyncThunks/user'
import { Skeleton } from '@/components/ui/skeleton'
import {
  initializeNotifications,
  disconnectNotifications,
} from './redux/asyncThunks/notification'
import { resetNotifications } from './redux/slices/notificationSlice'
import { getAccessToken } from './utils/authUtils'

function App() {
  const dispatch = useDispatch<AppDispatch>()

  const { userLoading, user, isAuthenticated } = useSelector(
    (state: RootState) => state.user
  )

  const jwtToken = getAccessToken()

  useEffect(() => {
    if (!user) {
      dispatch(fetchUserData())
    } else if (isAuthenticated && jwtToken) {
      dispatch(initializeNotifications({ jwtToken }))
    }
  }, [dispatch, user, isAuthenticated, jwtToken])

  useEffect(() => {
    if (isAuthenticated === false) {
      dispatch(disconnectNotifications())
      dispatch(resetNotifications())
    }
  }, [isAuthenticated, dispatch])

  if (userLoading) {
    return (
      <div className='fixed inset-0 flex items-center justify-center'>
        <div className='flex flex-col space-y-3'>
          <Skeleton className='h-[125px] w-[250px] rounded-xl' />
          <div className='space-y-2'>
            <Skeleton className='h-4 w-[250px]' />
            <Skeleton className='h-4 w-[200px]' />
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <AppRoutes />
    </>
  )
}

export default App
